import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SystemRoutingModule } from './system-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SystemRoutingModule
  ]
})
export class SystemModule { }
